import { ICGG2Report } from '@fortem-monorepo/web-sdk'

import { BetaStage } from '@/pages/funds/ic-guidelines-v2/components/stages/BetaStage'
import { DiversifiersStage } from '@/pages/funds/ic-guidelines-v2/components/stages/DiversifiersStage'
import { IncomeStage } from '@/pages/funds/ic-guidelines-v2/components/stages/IncomeStage'
import { ProtectionStage } from '@/pages/funds/ic-guidelines-v2/components/stages/ProtectionStage'
import { SummaryStage } from '@/pages/funds/ic-guidelines-v2/components/stages/SummaryStage'
import { BreachesStage } from '@/pages/funds/ic-guidelines-v2/components/stages/breaches-stage/BreachesStage'

type SectionComponents = {
  [TStageId in keyof ICGG2Report.IcGuidelinesStageOutputs]-?: React.FC<{
    output: NonNullable<ICGG2Report.IcGuidelinesStageOutputs[TStageId]>
    stageOutputs?: ICGG2Report.IcGuidelinesStageOutputs
  }>
}

export const SECTIONS: SectionComponents = {
  breaches: BreachesStage,
  summary: SummaryStage,
  income: IncomeStage,
  beta: BetaStage,
  diversifiers: DiversifiersStage,
  protection: ProtectionStage,
}
